// let BASE_API_URL = "http://121.196.212.2:8080";
// let BASE_API_URL = "http://km.zzly99.com:8080";
// let BASE_API_URL = "https://h5.zzly99.com";
// let BASE_API_URL = "https://admin.hongjianhl.com";
// let BASE_API_URL = "https://chx.zfkang.com";
let BASE_API_URL = "https://chxian.zfkang.com";

module.exports = {
  BASE_API_URL,
};
